const SETTLE_TIMEOUT_MS = 3000;
const READER_SCROLL_EVENTS = ['wheel', 'touchstart', 'keydown', 'mousedown'] as const;

/**
 * Keeps `element` `top` pixels below the viewport top while the page around it is still loading
 * and changing height. Stops once the reader scrolls or after a few seconds. Returns the stop
 * function.
 */
const pinScrollPosition = (element: Element, top: number) => {
  const scroller = element.closest('main');
  const content = scroller?.firstElementChild;
  if (!scroller || !content) {
    return () => {};
  }

  const stop = () => {
    observer.disconnect();
    clearTimeout(timeout);
    for (const event of READER_SCROLL_EVENTS) {
      window.removeEventListener(event, stop, { capture: true });
    }
  };
  // A detached element measures as all zeros, which would scroll the page by `top` on every resize.
  const align = () => {
    if (!element.isConnected) {
      stop();
      return;
    }
    scroller.scrollBy({ top: element.getBoundingClientRect().top - top });
  };
  const observer = new ResizeObserver(align);
  const timeout = setTimeout(stop, SETTLE_TIMEOUT_MS);
  // On `window`: a keydown from an unfocused page (PageDown, Space) never reaches `<main>`.
  for (const event of READER_SCROLL_EVENTS) {
    window.addEventListener(event, stop, { capture: true, passive: true });
  }
  observer.observe(content);
  align();
  return stop;
};

export default pinScrollPosition;
